import React, { useEffect, useRef, useState } from "react";
import { MdOutlineHistory, MdAdd } from "react-icons/md";
import { RxCross2 } from "react-icons/rx";

import CircularLoader from "../../../../../../Components/CircularLoader/CircularLoader";
import Tooltip from "../../../../../../Components/Tooltip/Tooltip";
import ConformModal from "../conformModal";
import CustomDropdown from "../customdropdown";
import FullfilmentBillingStatusHistoryModal from "../../../../../Shipper/Customer/MainPages/Orders/Components/FullfilmentBillingStatusHistoryModal/FullfilmentBillingStatusHistoryModal";
import { storeAdditionlCost } from "../../../../../../services/orders.services";
import { useTranslation } from "react-i18next";
import { useOrderVisibility } from "../../../../../../helpers/useOrderVisibility";

// Phones, tablets and touch screens: 44px fields with 16px text (so iPhones
// don't zoom in on focus); from lg with a mouse, the compact size.
const FIELD =
  "w-full min-h-[44px] rounded-md border border-ui-border bg-ui-surface px-2.5 py-1.5 text-[16px] text-ui-text placeholder-ui-text-subtle outline-none transition-colors focus:border-brand disabled:cursor-not-allowed disabled:opacity-60 lg:min-h-0 lg:text-[12px] [@media(pointer:coarse)]:min-h-[44px] [@media(pointer:coarse)]:text-[16px]";
const LABEL =
  "mb-1 block text-[10px] font-semibold uppercase tracking-wide text-ui-text-subtle";

const Line = ({ label, value, strong = false, onRemove }) => (
  <div className="flex items-baseline justify-between gap-3 py-[3px]">
    <span
      className={`min-w-0 truncate text-[11.5px] ${
        strong ? "font-semibold text-ui-text" : "text-ui-text-muted"
      }`}
    >
      {label}
    </span>
    <span className="flex shrink-0 items-center gap-1.5">
      <span
        className={`text-[11.5px] ${
          strong ? "font-semibold text-ui-text" : "text-ui-text-muted"
        }`}
      >
        {value}
      </span>
      {onRemove && (
        <RxCross2
          size={12}
          onClick={onRemove}
          className="cursor-pointer text-state-danger-text transition-opacity hover:opacity-70"
        />
      )}
    </span>
  </div>
);

export default function OrderFulfilment({
  data,
  setadditionalCosts,
  AdditionalCostTotal,
  setAdditionalCostTotal,
  additionalCosts,
  editable,
  deletedids,
  setdeletedids,
  setSnack,
  setData,
  setOrders,
  cost,
  setcost,
  value,
  setValue,
  open,
  additonalPrice,
  setadditonalPrice,
  selectedStatus,
  setselectedStatus,
  orderStatus,
  initial = false,
  // Given (by the order modal), picking a status calls it with the status
  // id and the modal opens its one status pop-up, shared with the header's
  // status. Without it, this section opens its own pop-up as before.
  onStatusChange,
}) {
  const { t } = useTranslation(["warehouse", "common"]);
  // Costs need "View price", as in the old view's section: without it the
  // status is all there is to change, and nothing shows to a login that
  // can't change it (the server sends the amounts blank, and refuses
  // additional costs).
  const { showPrices } = useOrderVisibility();
  const [CostCheck, setCostCheck] = useState([false]);
  const [loader, setloader] = useState(false);
  const [statusModal, setstatusModal] = useState(initial);
  const [qty, setQty] = useState(1);
  const [billingNotesHistoryModal, setBillingNotesHistoryModal] =
    useState(false);
  const setAdditionalCostRef = useRef(false);
  setAdditionalCostRef.current = false;

  useEffect(() => {
    if (!open[2]) {
      const selected =
        orderStatus.find(
          (status) => status.id === parseFloat(data?.fullfilment_status?.id),
        )?.id ?? "";
      setselectedStatus(selected);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderStatus]);

  useEffect(() => {
    if (setAdditionalCostRef.current === false && data?.additional_costs) {
      setadditionalCosts(
        data?.additional_costs.map((item) => ({
          ...item,
          name: item.cost_type?.name,
        })),
      );
      let totalCost;
      if (data?.additional_costs?.length > 0) {
        totalCost = data?.additional_costs.reduce(
          (accumulator, currentItem) =>
            accumulator + parseFloat(currentItem.cost),
          0,
        );
      }
      setadditonalPrice(totalCost);
      setAdditionalCostRef.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.additional_costs]);

  useEffect(() => {
    let y = 0;
    if (additionalCosts.length > 0) {
      additionalCosts.forEach((element) => {
        y = y + parseFloat(element.cost);
      });
    }
    setAdditionalCostTotal(y);
    const newData = additionalCosts.filter((item) => !item.id);
    setCostCheck(deletedids.length > 0 || newData.length > 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [additionalCosts]);

  const storeAdditonaldata = async () => {
    setloader(true);
    try {
      const newData = additionalCosts.filter((item) => !item.id);
      const payload = {
        new: newData.map(({ name, ...rest }) => rest),
        del: deletedids,
      };
      const response = await storeAdditionlCost(payload, data.id);

      if (!response.error) {
        setdeletedids([]);
        setOrders?.((prevOrder) => ({
          ...prevOrder,
          data: prevOrder?.data.map((order) =>
            order.id === data.id
              ? { ...order, additional_costs: response?.data?.result }
              : order,
          ),
        }));
        setData({ ...data, additional_costs: response?.data?.result });
        setCostCheck(false);
        setSnack({
          open: true,
          text: response?.data?.message,
          severity: "success",
        });
      } else {
        setSnack({
          open: true,
          text: t("orderView.somethingWentWrongTryAgainLater"),
          severity: "error",
        });
      }
    } catch (error) {
      setSnack({
        open: true,
        text: error?.response?.data?.message || t("common:messages.somethingWentWrong"),
        severity: "error",
      });
    } finally {
      setloader(false);
    }
  };

  // The order's status as saved: what the select shows when the modal owns
  // the pop-up (a declined change leaves the order, and so the select, as
  // it was).
  const currentStatusId =
    orderStatus.find(
      (status) => String(status.id) === String(data?.fullfilment_status?.id),
    )?.id ?? "";

  const handlestatusChange = (event) => {
    // A <select> gives the id as text; the status pop-up compares ids as
    // numbers (=== 5 for Attention, and to find the status's name), so the
    // status is passed on with its own id. Passing the text opened a pop-up
    // without the Attention fields or the status name.
    const picked = orderStatus.find(
      (status) => String(status.id) === String(event.target.value),
    );
    if (!picked) return;
    if (onStatusChange) {
      onStatusChange(picked.id);
      return;
    }
    setselectedStatus(picked.id);
    setstatusModal(true);
  };

  const handleRemoveCost = (index, item) => {
    if (item.id) setdeletedids([...deletedids, item.id]);
    const list = [...additionalCosts];
    list.splice(index, 1);
    setadditionalCosts(list);
  };

  const handleadditionalcost = () => {
    if (!value) {
      setSnack({
        open: true,
        text: t("orderView.costTypeIsRequired"),
        severity: "error",
      });
      return;
    }

    const quantity = parseInt(qty) || 1;
    const parsedCost = parseFloat(cost) || 0;
    setadditonalPrice(parseFloat(additonalPrice) + parsedCost * quantity);

    const newCosts = Array.from({ length: quantity }, () => ({
      costtype_id: value.id,
      cost: cost,
      name: value.name,
      order_id: data?.id,
    }));

    setadditionalCosts([...additionalCosts, ...newCosts]);
    setcost(null);
    setValue(null);
    setQty(1);
  };

  const shownStatus = onStatusChange ? currentStatusId : selectedStatus;
  const statusDisabled =
    String(shownStatus) === "6" ||
    data?.status !== "Confirmed" ||
    data?.type === "Return";

  const statusHint =
    data?.type === "Return"
      ? t("orderView.orderIsReturn")
      : data?.status !== "Confirmed"
        ? t("orderView.orderNotConfirmed")
        : "";

  const unitType = data?.formula?.["UnitType"];
  const preProductCount = data?.formula?.["TotalPreProduct"];
  const currency = data?.currency || "CAD";

  // The API can send the literal string "NaN" for this field.
  const rawWeight = data?.formula?.["TotalFulfilmentWeight"];
  const fulfilmentWeight = Number.isFinite(parseFloat(rawWeight))
    ? rawWeight
    : 0;

  if (!showPrices && !editable) return null;

  return (
    <>
      {!onStatusChange && (
        <ConformModal
          data={data}
          setData={setData}
          open={statusModal}
          setOpen={setstatusModal}
          selectedStatus={selectedStatus}
          orderStatus={orderStatus}
          setOrders={setOrders}
          setselectedStatus={setselectedStatus}
          setSnack={setSnack}
        />
      )}

      <FullfilmentBillingStatusHistoryModal
        open={billingNotesHistoryModal}
        setOpen={setBillingNotesHistoryModal}
        setSnack={setSnack}
      />

      <div
        className={`grid grid-cols-1 gap-3 ${
          editable && showPrices
            ? "lg:grid-cols-[minmax(0,1fr)_minmax(0,320px)]"
            : ""
        }`}
      >
        {editable && (
          <div className="flex flex-col gap-3">
            <div className="min-w-0">
              <label
                htmlFor={`fulfilment-status-${data?.id}`}
                className={LABEL}
              >
                Fulfilment status
              </label>
              <Tooltip title={statusHint}>
                <span className="block">
                  <select
                    id={`fulfilment-status-${data?.id}`}
                    value={shownStatus || ""}
                    onChange={handlestatusChange}
                    disabled={statusDisabled}
                    className={FIELD}
                  >
                    <option value="">{t("orderView.selectStatus")}</option>
                    {orderStatus.map((status) => (
                      <option
                        key={status.id}
                        value={status.id}
                        disabled={Boolean(status?.disabled)}
                      >
                        {status.name.toUpperCase()}
                      </option>
                    ))}
                  </select>
                </span>
              </Tooltip>
            </div>

            {/* Phones: the cost type on its own line, then cost, qty and
                the add button; from sm up one row, as before. */}
            {showPrices && (
            <div className="grid grid-cols-[minmax(0,1fr)_minmax(0,1fr)_auto] items-end gap-2 sm:flex sm:flex-wrap">
              <div className="col-span-3 min-w-0 sm:min-w-[160px] sm:flex-1">
                <label className={LABEL}>{t("orderView.costType")}</label>
                <CustomDropdown
                  setValue={setValue}
                  value={value}
                  setcost={setcost}
                />
              </div>

              <div className="min-w-0 sm:w-24">
                <label className={LABEL}>{t("orderView.cost")}</label>
                <input
                  type="number"
                  inputMode="decimal"
                  name="cost"
                  value={cost || ""}
                  onChange={(event) => setcost(event.target.value)}
                  placeholder="0.00"
                  className={FIELD}
                />
              </div>

              <div className="min-w-0 sm:w-20">
                <label className={LABEL}>{t("orderView.qty")}</label>
                <input
                  type="number"
                  inputMode="numeric"
                  name="qty"
                  value={qty || ""}
                  onChange={(event) => setQty(event.target.value)}
                  placeholder="1"
                  className={FIELD}
                />
              </div>

              <Tooltip title={t("orderView.addAdditionalCost")}>
                <button
                  type="button"
                  aria-label={t("orderView.addAdditionalCost")}
                  onClick={handleadditionalcost}
                  className="flex h-[44px] w-[44px] items-center justify-center rounded-md border border-ui-border bg-ui-surface text-ui-text-muted transition-colors hover:border-brand hover:text-brand lg:h-[30px] lg:w-[30px] [@media(pointer:coarse)]:h-[44px] [@media(pointer:coarse)]:w-[44px]"
                >
                  <MdAdd size={16} />
                </button>
              </Tooltip>
            </div>
            )}

            {showPrices && CostCheck && (
              <div>
                <button
                  type="button"
                  onClick={storeAdditonaldata}
                  disabled={loader}
                  className="flex min-h-[44px] w-full items-center justify-center gap-1.5 rounded-md bg-brand px-4 py-1.5 text-[13px] font-semibold text-brand-contrast transition-colors hover:bg-brand-hover disabled:opacity-60 sm:w-auto lg:min-h-0 lg:text-[12px] [@media(pointer:coarse)]:min-h-[44px]"
                >
                  {loader && <CircularLoader size={12} />}
                  {t("common:actions.save")}
                </button>
              </div>
            )}
          </div>
        )}

        {showPrices && (
        <div
          className={`rounded-lg border border-ui-border bg-ui-surface-sunken p-2.5 ${editable ? "" : "lg:max-w-[420px]"}`}
        >
          <div className="mb-1.5 text-[10px] font-semibold uppercase tracking-wide text-ui-text-subtle">
            {t("orderView.fulfilmentCost")}
          </div>

          <Line
            label={`${unitType === "CBM" ? t("orderView.volume") : t("orderView.weight")} (${
              fulfilmentWeight
            } ${unitType ?? ""})`}
            value={`${data?.formula?.["TotalWeightCost"] ?? 0} ${currency}`}
            strong
          />

          {preProductCount > 0 && (
            <>
              <hr className="my-1 border-ui-border" />
              <Line
                label={t("orderView.preCostItemQuantity", { quantity: preProductCount })}
              />
              {data?.order_details
                ?.filter((item) => item?.products?.fulfillment_cost)
                .map((item, index) => (
                  <Line
                    key={index}
                    label={`${item.product_name} (${item.item_quantity} × ${item.products?.fulfillment_cost})`}
                    value={`${item.products?.fulfillment_cost * item.item_quantity} ${currency}`}
                  />
                ))}
              <Line
                label=""
                value={`${data?.formula?.["TotalPreCost"]} ${currency}`}
                strong
              />
            </>
          )}

          {additionalCosts?.length > 0 && (
            <>
              <hr className="my-1 border-ui-border" />
              <Line
                label={t("orderView.additionalCostCount", { number: additionalCosts.length })}
                strong
              />
              {additionalCosts.map((item, index) => (
                <Line
                  key={index}
                  label={item.name}
                  value={`${item?.cost} ${currency}`}
                  onRemove={
                    editable ? () => handleRemoveCost(index, item) : undefined
                  }
                />
              ))}
              <Line
                label={t("orderView.totalAdditionalCost")}
                value={`${AdditionalCostTotal} ${currency}`}
                strong
              />
            </>
          )}

          <hr className="my-1 border-ui-border" />

          <div className="text-[10px] font-semibold uppercase tracking-wide text-ui-text-subtle">
            {t("orderView.fulfilmentBillingNote")}
          </div>
          <div className="mt-0.5 flex items-start justify-between gap-2">
            <p className="m-0 min-w-0 flex-1 text-[11.5px] text-ui-text-muted">
              {data?.fullfullment_billing_status_history?.at(-1)?.properties
                ?.notes ?? t("orderView.noNoteAvailable")}
            </p>
            <Tooltip title={t("orderView.billingStatusHistory")}>
              <button
                type="button"
                onClick={() => setBillingNotesHistoryModal(data)}
                className="shrink-0 text-ui-text-muted transition-colors hover:text-brand"
              >
                <MdOutlineHistory size={15} />
              </button>
            </Tooltip>
          </div>

          <hr className="my-1 border-ui-border" />

          <div className="flex items-baseline justify-between gap-3">
            <span className="text-[12px] font-semibold text-ui-text">
              {t("orderView.totalFulfilmentCost")}
            </span>
            <span className="text-[13px] font-semibold text-ui-text">
              {(
                (parseFloat(data?.formula?.["TotalFulfilmentCost"]) || 0) +
                (parseFloat(AdditionalCostTotal) || 0)
              ).toFixed(2)}{" "}
              {currency}
            </span>
          </div>
        </div>
        )}
      </div>
    </>
  );
}
